<template>
  <div class="fanshui_ratio" @click="key_status = false;type_status = false;">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()" />
      </div>
      <span class="head_text">{{ $t('返水比例') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="content">
      <div class="table-header tr">
        <div class="td">
          <div class="select-box">
            <div :class="['input-box', key_status ? 'active': '']" @click.stop="type_status = false; key_status = !key_status">
              <span class="name">{{list[table_key][table_index].name}}</span>
              <div class="icon">
                <van-icon :name="key_status? 'arrow-up' : 'arrow-down' "/>
              </div>
            </div>
            <div class="select-list" v-show="key_status">
              <div :class="['select-item', table_key === key ? 'active': '']" v-for="(item, key, index) in list" @click.stop="selectTableKey(key, item[0].type)">
                {{item[0].name}}
              </div>
            </div>
          </div>
        </div>
        <div class="td">
          <div class="select-box">
            <div :class="['input-box', type_status ? 'active': '']" @click.stop="key_status = false; type_status = !type_status">
              <span class="name">{{table_type}}</span>
              <div class="icon">
                <van-icon :name="type_status? 'arrow-up' : 'arrow-down' "/>
              </div>
            </div>
            <div class="select-list" v-show="type_status">
              <div :class="['select-item', table_type === item.type ? 'active': '']" v-for="(item, index) in list[table_key]" @click.stop="selectTableType(item.type, index)">
                {{item.type}}
              </div>
            </div>
          </div>
        </div>
        <div class="td">{{ $t('当日累计投注') }}</div>
        <div class="td">{{ $t('反水比例') }}</div>
      </div>
      <div class="table-box">
        <div class="table-body" v-if="Object.keys(list).length > 0">
          <div class="tr" v-for="(item, index) in list[table_key][table_index].ratio">
            <div class="td">{{list[table_key][table_index].name}}</div>
            <div class="td">{{list[table_key][table_index].type}}</div>
            <div class="td">{{item.label}}</div>
            <div class="td">{{item.value}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fanshui_ratio',
  data(){
    return {
      table_key: 'live',
      table_type: 'AG',
      table_index: 0,
      list: {},

      key_status: false,
      type_status: false,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.list = {
        live: [
          {
            name: this.$t('真人'),
            type: 'AG',
            ratio: [
              {
                label: '≥1+',
                value: '0.50%'
              },
              {
                label: '≥100000+',
                value: '0.60%'
              },
              {
                label: '≥3000000+',
                value: '0.80%'
              },
              {
                label: '≥10000000+',
                value: '1.00%'
              },
              {
                label: '≥20000000+',
                value: '1.50%'
              }
            ]
          },
          {
            name: this.$t('真人'),
            type: 'BG',
            ratio: [
              {
                label: '≥1+',
                value: '0.50%'
              },
              {
                label: '≥100000+',
                value: '0.60%'
              },
              {
                label: '≥3000000+',
                value: '0.80%'
              },
              {
                label: '≥10000000+',
                value: '1.00%'
              },
              {
                label: '≥20000000+',
                value: '1.50%'
              }
            ]
          },
        ],
        electronic: [
          {
            name: this.$t('电子'),
            type: 'AG',
            ratio: [
              {
                label: '≥1+',
                value: '0.60%'
              },
              {
                label: '≥100000+',
                value: '1.00%'
              },
              {
                label: '≥3000000+',
                value: '1.50%'
              },
              {
                label: '≥10000000+',
                value: '2.00%'
              },
              {
                label: '≥20000000+',
                value: '2.50%'
              }
            ]
          },
          {
            name: this.$t('电子'),
            type: 'PG',
            ratio: [
              {
                label: '≥1+',
                value: '1.00%'
              },
              {
                label: '≥100000+',
                value: '1.50%'
              },
              {
                label: '≥3000000+',
                value: '2.00%'
              },
              {
                label: '≥10000000+',
                value: '2.80%'
              },
              {
                label: '≥20000000+',
                value: '3.50%'
              }
            ]
          },
          {
            name: this.$t('电子'),
            type: this.$t('转运金'),
            ratio: [
              {
                label: '≥100+',
                value: '1.00%'
              },
              {
                label: '≥2000+',
                value: '2.00%'
              },
              {
                label: '≥10000+',
                value: '3.00%'
              },
              {
                label: '≥50000+',
                value: '4.00%'
              },
              {
                label: '≥100000+',
                value: '5.00%'
              }
            ]
          },
        ],
        chess: [
          {
            name: this.$t('开元棋牌'),
            type: 'AG',
            ratio: [
              {
                label: '≥1+',
                value: '0.60%'
              },
              {
                label: '≥100000+',
                value: '1.00%'
              },
              {
                label: '≥3000000+',
                value: '1.50%'
              },
              {
                label: '≥10000000+',
                value: '2.00%'
              },
              {
                label: '≥20000000+',
                value: '2.50%'
              }
            ]
          },
          {
            name: this.$t('开元棋牌'),
            type: this.$t('转运金'),
            ratio: [
              {
                label: '≥100+',
                value: '1.00%'
              },
              {
                label: '≥2000+',
                value: '2.00%'
              },
              {
                label: '≥10000+',
                value: '3.00%'
              },
              {
                label: '≥50000+',
                value: '4.00%'
              },
              {
                label: '≥100000+',
                value: '5.00%'
              }
            ]
          },
        ],
        sports: [
          {
            name: this.$t('体育'),
            type: 'KY',
            ratio: [
              {
                label: '≥1+',
                value: '0.50%'
              },
              {
                label: '≥100000+',
                value: '0.60%'
              },
              {
                label: '≥3000000+',
                value: '0.80%'
              },
              {
                label: '≥10000000+',
                value: '1.00%'
              },
              {
                label: '≥20000000+',
                value: '1.50%'
              }
            ]
          },
          {
            name: this.$t('体育'),
            type: this.$t('转运金'),
            ratio: [
              {
                label: '≥200+',
                value: '6'
              },
              {
                label: '≥1000+',
                value: '16'
              },
              {
                label: '≥3000+',
                value: '36'
              },
              {
                label: '≥10000+',
                value: '196'
              },
              {
                label: '≥50000+',
                value: '396'
              },
              {
                label: '≥100000+',
                value: '966'
              },
              {
                label: '≥300000+',
                value: '1966'
              },
              {
                label: '≥500000+',
                value: '9666'
              }
            ]
          },
        ]
      }
    },
    selectTableKey(key, type) {
      this.table_key = key;
      this.table_type = type;
      this.table_index = 0
      this.$forceUpdate()
      this.key_status = false
    },
    selectTableType(type, index) {
      this.table_type = type;
      this.table_index = index
      this.$forceUpdate()
      this.type_status = false
    }
  }
}
</script>


<style scoped lang="scss">
.fanshui_ratio {
  width: 100%;
  min-height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    padding: 0 .2rem;
    width: 100%;
    height: calc(100Vh - 46px);
    color: #999999;
    .select-box {
      position: relative;
      .input-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(255, 255, 255, 0.10);
        border: 0.03rem solid rgba(255, 255, 255, 0.10);
        border-radius: 1rem;
        width: 2.35rem;
        height: .77rem;
        padding: 0 .34rem;
        box-sizing: border-box;
        &.active {
          color: #4B5BF1;
          border-color: #4B5BF1;
        }
        .name {
          font-size: .3rem;
        }
      }
      .select-list {
        position: absolute;
        left: 0;
        right: .1rem;
        background: rgba(0, 0, 0, 1);
        border: 0.03rem solid rgba(255, 255, 255, 0.3);
        overflow: auto;
        box-shadow: 0 .02rem .8rem rgba(0,0,0,.1);
        max-height: 7rem;
        border-radius: .2rem;
        padding: 0rem .2rem;
        text-align: left;
        .select-item {
          height: 1rem;
          display: flex;
          align-items: center;
          letter-spacing: .12rem;
          &.active {
            color: #4B5BF1;
          }
        }
      }
    }
    .tr {
      min-height: .99rem;
      display: flex;
      align-items: center;
      width: 100%;
      .td {
        width: calc(100% / 4);
        text-align: center;
        font-size: .32rem;
        color: #fff;
      }
    }
    .table-header {
      min-height: 1.23rem;
    }
    .table-box {
      height: calc(100% - 1.8rem);
      overflow: auto;
    }
    .table-body {
      background: rgba(255, 255, 255, 0.10);
      border: 0.03rem solid rgba(255, 255, 255, 0.10);
      border-radius: .19rem;
      overflow: hidden;
      .tr:nth-child(odd) {
        background: rgba(255, 255, 255, 0.10);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fanshui_ratio.vue